module.exports = __webpack_public_path__ + "static/1293887654.9965197b.jpg";